import React, {FC, useRef, useEffect} from 'react'

import Form from '@/components/Form'
import { Button } from '@/components/UiElements'

import hatchProfileFormItems from '@/components/HatchProfile/forms/hatchProfileFormItems'
import { closeNotif, startNotif } from '@/components/DynamicForm/util/notifier'

import mapFormDataToApiProfile from '@/components/HatchProfile/saveData/mapFormDataToApiProfile'
import saveHatchProfile from '@/services/ProductService/saveHatchProfile'
import Splash from '@/components/splash/Splash'

interface HatchProfileFormProps {
	profile: any | null
	onUpdateSuccess: () => void
	onCancel?: () => void
}


const HatchProfileForm: FC<HatchProfileFormProps> = ({ profile, onUpdateSuccess, onCancel }) => {

	const formRef = useRef<any>(null)
	const [loading, setLoading] = React.useState<boolean>(false)

	const handleSaveProfile = async ()=> {
		setLoading(true)
		const notifId = startNotif("Saving Hatch profile...")
		const data = formRef.current?.getData()
		const mappedData = mapFormDataToApiProfile(data)
		const updatedProfile = await saveHatchProfile(mappedData)

		console.log(updatedProfile)
		if (updatedProfile.id) {
			closeNotif(notifId, "Hatch profile saved successfully", "success")
			onUpdateSuccess()
		} else {
			closeNotif(notifId, "Failed to save Hatch profile", {"type": "error"})
		}
		setLoading(false)


		onUpdateSuccess()
	}



	useEffect(() => {
		formRef.current.setData(profile || {})
	}, [profile])

	return (
		<div className={'flex flex-col gap-xxxl'}>
			{loading && <Splash/>}
			<div className={'w-[850px] grid grid-cols-12 gap-md'}>
				<Form
					ref={formRef}
					items={hatchProfileFormItems}
					defaultValues={profile || {}}

				/>
			</div>
			<div className={'flex justify-end gap-md'}>
				{onCancel && (
					<Button
						size="lg"
						type="alt"
						onClick={onCancel}
						disabled={loading}
					>
						Cancel
					</Button>
				)}
				<Button
					size="lg"
					onClick={handleSaveProfile}
					disabled={loading}
				>
					{profile ? 'Update Hatch Profile' : 'Add Hatch Profile'}
				</Button>
			</div>
		</div>
	)
}


export default HatchProfileForm
